module.exports = __webpack_public_path__ + "basic.png?08ee789104df0c13650618b53f6c38bd";